<div class="modal-header smodal-header">
  <h4 class="modal-title smodal-title fl">년월선택</h4>
  <button type="button" class="close" (click)="activeModal.dismiss()">&times;</button>
</div>

<div class="modal-body smodal-body">
  <app-month-picker (change)="onChange($event)"></app-month-picker>
  <div class="cb"></div>
</div>

<div class="modal-footer smodal-footer">
  <button type="button" class="btn btn-primary btn-small" (click)="setDate()">적용하기</button>
</div>
